// extracted by mini-css-extract-plugin
module.exports = {"container":"MapItem_container__S0iMW","image":"MapItem_image__3mf0C","name":"MapItem_name__xjJuM","selectServer":"MapItem_selectServer__2kzB4","playNow":"MapItem_playNow__3clEE"};